<template>
  <nav
    class="navbar navbar-expand-md bg-primary navbar-dark"
    id="header"
  >
    <div class="container-fluid px-1">
      <a
        class="navbar-brand"
        href="#"
      >
        <div class="logo">
          <div class="d-inline-block">
            <router-link to="/templates">
              <img
                class="mb-2"
                src="https://cdn.thinkwebcontent.com/assets/thinkspain.com/images/logo_white_background.png"
                alt=""
                width="auto"
                height="30"
              >
            </router-link>
          </div>
        </div>
      </a>
      <div
        v-if="auth"
        class="navbar-toggler navbar-toggler-right collapsed"
        data-toggle="collapse"
        data-target="#top-menu"
      >
        <span class="navbar-toggler-icon" />
      </div>
      <div
        v-if="auth"
        class="collapse navbar-collapse"
        id="top-menu"
      >
        <hr class="d-md-none d-lg-none d-xl-none">
        <ul class="navbar-nav mr-auto">
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('locationsmanagement:*')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              Locations
            </a>
            <div class="dropdown-menu bg-primary">
              <router-link
                to="/locations"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
              >
                Dashboard
              </router-link>
              <router-link
                to="/locations/create"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
              >
                Create Location
              </router-link>
              <router-link
                to="/shape-viewer"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
              >
                Shape Viewer
              </router-link>
              <router-link
                to="/locations/verification"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
              >
                Run Verification
              </router-link>
            </div>
          </li>
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('narratosync:read')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              Narrato
            </a>
            <div class="dropdown-menu bg-primary">
              <router-link
                to="/narrato-sync"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
              >
                Sync
              </router-link>
              <router-link
                to="/utilities"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
              >
                Utilities
              </router-link>
            </div>
          </li>
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('emailtemplate:*') || hasPolicyWithAnyAction('campaign:*')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              Mailshots
            </a>
            <div class="dropdown-menu bg-primary">
              <router-link
                to="/templates"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('emailtemplate:*')"
              >
                Templates
              </router-link>
              <router-link
                to="/campaigns"
                class="nav-link d-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('campaign:*')"
              >
                Campaigns
              </router-link>
            </div>
          </li>
          <li v-if="hasPolicyWithAnyAction('feature:*')">
            <router-link
              to="/features"
              class="nav-link d-sm-inline-block float-sm-none"
              data-parent="#top-menu"
            >
              Features
            </router-link>
          </li>
          <li v-if="hasPolicyWithAnyAction('locationmapping:*')">
            <router-link
              to="/altnames"
              class="nav-link d-sm-inline-block float-sm-none"
              data-parent="#top-menu"
            >
              Alt Location Names
            </router-link>
          </li>
          <li v-if="hasPolicyWithAnyAction('emailevent:*')">
            <router-link
              to="/emailevents"
              class="nav-link d-sm-inline-block float-sm-none"
              data-parent="#top-menu"
            >
              Email Events
            </router-link>
          </li>
          <li v-if="hasPolicyWithAnyAction('featuredhistory:*')">
            <router-link
              to="/featuredhistory"
              class="nav-link d-sm-inline-block float-sm-none"
              data-parent="#top-menu"
            >
              Featured History
            </router-link>
          </li>
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('clientanalytics:*') || hasPolicyWithAnyAction('analytics:*')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              Analytics
            </a>
            <div
              class="dropdown-menu bg-primary"
            >
              <router-link
                to="/propertyanalytics"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('clientanalytics:*')"
              >
                Property Analytics
              </router-link>
              <router-link
                to="/directoryanalytics"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('clientanalytics:*')"
              >
                Directory Analytics
              </router-link>
              <router-link
                to="/analytics"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('analytics:*')"
              >
                Analytics
              </router-link>
            </div>
          </li>
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('enquiry:*', 'enquiry:property:*', 'enquiry:property:read:*', 'enquiry:property:read:non-spam') || hasPolicyWithAnyAction('enquiry:*', 'enquiry:directory:*', 'enquiry:directory:read:*', 'enquiry:directory:read:non-spam')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              Enquiries
            </a>
            <div class="dropdown-menu bg-primary">
              <router-link
                to="/propertyenquiry"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('enquiry:*', 'enquiry:property:*', 'enquiry:property:read:*', 'enquiry:property:read:non-spam')"
              >
                Property enquiries
              </router-link>
              <router-link
                v-if="hasPolicyWithAnyAction('enquiry:*', 'enquiry:directory:*', 'enquiry:directory:read:*', 'enquiry:directory:read:non-spam')"
                to="/directoryenquiry"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
              >
                Directory enquiries
              </router-link>
            </div>
          </li>
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('xml-import:*', 'xml-import-rule:*', 'xml-alternative-name:*')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              XML
            </a>
            <div class="dropdown-menu bg-primary">
              <router-link
                to="/xmldashboard"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
              >
                Dashboard
              </router-link>
              <router-link
                to="/xmlimport"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
              >
                Import History
              </router-link>
              <router-link
                to="/xmlimportrules"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('xml-import-rule:*')"
              >
                Rules
              </router-link>
              <router-link
                to="/xmlalternativenames"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
                v-if="hasPolicyWithAnyAction('xml-alternative-name:*')"
              >
                Alternative Names
              </router-link>
              <router-link
                to="/ftp"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
              >
                FTP files
              </router-link>
            </div>
          </li>
          <li
            class="nav-item dropdown"
            v-if="hasPolicyWithAnyAction('unindexed-urls:*')"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-toggle="dropdown"
            >
              GSC
            </a>
            <div class="dropdown-menu bg-primary">
              <router-link
                to="/gsc/unindexed-urls"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
              >
                Unindexed URLs
              </router-link>
              <router-link
                to="/gsc/inspection-results"
                class="nav-link d-sm-inline-block float-sm-none"
                data-parent="#top-menu"
              >
                Unindexed URL Inspection Results
              </router-link>
            </div>
          </li>
          <!-- <li v-if="hasPolicyWithAnyAction('propertyqc:*')">
            <router-link
              to="/property-quality-control"
              class="nav-link d-sm-inline-block float-sm-none"
              data-parent="#top-menu"
            >
              Property QC
            </router-link>
          </li> -->
          <hr class="d-md-none d-lg-none d-xl-none">
          <div class="d-inline m-0">
            <ul class="d-inline">
              <li class="nav-item pt-lg-0 pt-md-0 d-inline-block">
                <div
                  class="dropdown show nav-link"
                  id="profile"
                >
                  <a
                    class="profletter"
                    href="javascript:;"
                    id="dropdownMenuProfile"
                    data-boundary="viewport"
                    data-flip="true"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span v-html="firstLetter" />
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuProfile"
                  >
                    <div class="py-2 text-small">
                      <div class="profletter text-dark">
                        <span v-html="firstLetter" />
                      </div>
                    </div>
                    <div class="profemail">
                      {{ email }}
                    </div>
                    <div class="px-2">
                      <hr>
                    </div>

                    <a
                      @click="onLogout"
                      to="/logout"
                      href="#"
                      id="logoutBnt"
                      class="nav-link"
                    >
                      <i class="jam jam-power align-middle pb-1" /> LogOut
                    </a>
                  </div>
                  <div class="" />
                </div>
              </li>
            </ul>
          </div>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import store from '../../store';
import { hasPolicyWithAllActions, hasPolicyWithAnyAction } from '../../auth/index';

export default {
    computed: {
        auth() {
            return store.getters.isAuthenticated;
        },
        firstLetter() {
            return store.state.user.Email !== null ? store.state.user.Email.charAt( 0 ) : '';
        },
        email() {
            return store.state.user.Email;
        }
    },
    methods: {
        onLogout() {
            store.dispatch( 'logout' );
        },
        hasPolicyWithAnyAction( ...actionPrefix ) {
            return hasPolicyWithAnyAction( store.state.user, ...actionPrefix );
        },
        hasPolicyWithAllActions( ...actionPrefix ) {
            return hasPolicyWithAllActions( store.state.user, ...actionPrefix );
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/header/header.vue